import { MatFormFieldDefaultOptions } from '@angular/material/form-field';

export const layoutDefaults = {
  formField: <MatFormFieldDefaultOptions>{
    appearance: 'outline',
    floatLabel: 'auto',
  },
};
